module.exports = __webpack_public_path__ + "img/About-food-image.61b38d50.png";